// Shared tour configuration for all tours
export const tourOptions = {
  exitOnOverlayClick: false,
  showStepNumbers: false,
  doneLabel: '✓',
  nextLabel: '→',
  prevLabel: '←',
  skipLabel: '×',
  hidePrev: false,
  hideNext: false,
  tooltipClass: 'custom-intro-tooltip',
  highlightClass: 'custom-intro-highlight',
  overlayOpacity: 0.8,
  scrollToElement: true,
  scrollPadding: 5,
  showProgress: false,
  showBullets: false,
  keyboardNavigation: true,
  disableInteraction: false
};